/*
 * File: DemographicFormModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Form data for patient/account create forms
 */
import { phoneTypes, sexTypes } from "services/references/References";
import countries from "services/references/countries";
import states from "services/references/states";

const DemographicFormModel = [
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    htmlInputProps: { maxLength: "30" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true,
    htmlInputProps: { maxLength: "30" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "middle",
    label: "Middle",
    type: "text",
    htmlInputProps: { maxLength: "20" },
    gridItemProps: { xs: 12, sm: 4 }
  },
  {
    name: "prefix",
    label: "Prefix",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "6" },
    gridItemProps: { xs: 12, sm: 4 }
  },
  {
    name: "suffix",
    label: "Suffix",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "6" },
    gridItemProps: { xs: 12, sm: 4 }
  },
  {
    name: "maidenName",
    label: "Maiden Name",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "40" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "nickname",
    label: "Nickname",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "20" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "birthdate",
    label: "Birth Date",
    type: "date",
    required: false,
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "sex",
    label: "Sex",
    type: "select",
    options: sexTypes,
    required: false,
    isInt: true,
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "governmentIdentifier",
    label: "Social Security Number",
    type: "text",
    hidden: true
  },
  {
    name: "maritalStatus",
    label: "Marital Status",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "employment",
    label: "Employment",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "preferredLanguageId",
    label: "Preferred Language",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "relationshipToPrimary",
    label: "Relationship to Primary",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "relationshipToSecondary",
    label: "Relationship to Secondary",
    type: "select",
    options: [],
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "streetAddress",
    label: "Street Address",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "60" },
    gridItemProps: { xs: 12, sm: 9 }
  },
  {
    name: "suite",
    label: "Suite/Apt. #",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "60" },
    gridItemProps: { xs: 12, sm: 3 }
  },
  {
    name: "country",
    label: "Country",
    type: "autocomplete",
    options: countries,
    required: false,
    gridItemProps: { xs: 12, sm: 6 },
    placeholder: "Type the name of the Country..."
  },
  {
    name: "zipCode",
    label: "Zip Code",
    type: "zip",
    required: false,
    htmlInputProps: { maxLength: "15" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: false,
    htmlInputProps: { maxLength: "30" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "state",
    label: "State",
    type: "autocomplete",
    options: states,
    required: false,
    gridItemProps: { xs: 12, sm: 6 },
    placeholder: "Type the name of the State..."
  },
  {
    name: "phone1",
    label: "Phone Number 1",
    type: "phone",
    required: false,
    htmlInputProps: { maxLength: "20" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "phone1Type",
    label: "Phone Number 1 Type",
    type: "select",
    options: phoneTypes,
    required: false,
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "phone2",
    label: "Phone Number 2",
    type: "phone",
    required: false,
    htmlInputProps: { maxLength: "20" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "phone2Type",
    label: "Phone Number 2 Type",
    type: "select",
    options: phoneTypes,
    required: false,
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "phone3",
    label: "Phone Number 3",
    type: "phone",
    required: false,
    htmlInputProps: { maxLength: "20" },
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "phone3Type",
    label: "Phone Number 3 Type",
    type: "select",
    options: phoneTypes,
    required: false,
    gridItemProps: { xs: 12, sm: 6 }
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    htmlInputProps: { maxLength: "100" },
    required: false
  }
];

export default DemographicFormModel;
